import { useRef } from 'react';
import { uniqueId } from 'lodash';

/**
 * Returns a unique form field ID that is consistent between re-renders
 */
export default function useFormId(name) {
    const id = useRef(uniqueId(`${name}-`));
    return id.current;
}
